module.exports = __webpack_public_path__ + "img/Apoint6.908786c7.png";